import { themeConfig } from 'src/theme/theme-config'

export const defaultSettings = {
  colorScheme: themeConfig.defaultMode,
  direction: themeConfig.direction,
  contrast: 'default',
  navColor: 'integrate',
  compactLayout: true,
  fontSize: 18,
  fontFamily: themeConfig.fontFamily.primary
}
